import React, { Component, createRef } from "react";

import { Button, Card, CardBody, Col, Container, Row } from "reactstrap";
import { withTranslation } from "react-i18next";
import { Field, ErrorMessage } from "formik";

//Import Breadcrumb
import Breadcrumbs from "../Common/Breadcrumb";

class ViewVarifyAndAccept extends Component {
  constructor(props) {
    super(props);
    this.state = {
    };
  }


  render() {
    //meta title
    document.title = "grader flow";
    return (
      <React.Fragment>
        <div className="page-content">
          <Container fluid={true}>
            <Breadcrumbs breadcrumbItem="View Verify & Accept" />
            <Row>
              <Col xl="12">
                <Card>
                  <CardBody>
                    <div className="d-lg-flex d-block justify-content-between">
                      <div>
                        <h4 className="pb-3 text-black fw-bold">
                        View Verify & Accept 
                        </h4>
                      </div>
                      {/* <div>
                        <label
                          htmlFor="date"
                          className="pe-2 fs-5 fw-bold text-black"
                        >
                          Date:
                        </label>
                        <input
                          disabled
                          type="date"
                          className="fs-5 border-0 text-black"
                        />
                      </div> */}
                    </div>
                        <form>
                            <div className="mb-3 row">
                              <label
                                htmlFor="inwardID"
                                className="col-md-2 col-form-label"
                              >
                                <h5 className="text-secondary fw-bold">
                                  {this.props.t('Jangad No')}
                                </h5>
                              </label>
                              <div className="col-md-10 col-12">
                                <input
                                  className="form-control fs-5"
                                  disabled
                                  type="text"
                                  name="inwardID"
                                  placeholder="JANGAD0000123"
                                />
                              </div>
                            </div>
                            <div className="mb-3 row">
                              <label
                                htmlFor="partyCode"
                                className="col-md-2 col-form-label"
                              >
                                <h5 className="text-secondary fw-bold">
                                  {this.props.t('Party Code')}
                                </h5>
                              </label>
                              <div className="col-md-10 col-12">
                                <input
                                  className="form-control fs-5"
                                  type="text"
                                  name="partyCode"
                                  placeholder="COMPANY000123"
                                />
                              </div>
                            </div>
                            <div className="mb-3 row">
                              <label
                                htmlFor="hpht"
                                className="col-md-2 col-form-label"
                              >
                                <h5 className="text-secondary fw-bold">HPHT</h5>
                              </label>
                              <div className="col-md-10 col-12">
                                <input
                                  className="form-control fs-5"
                                  disabled
                                  type="text"
                                  name="hpht"
                                  placeholder="12"
                                />
                              </div>
                            </div>

                            <div className="mb-3 row">
                              <label
                                htmlFor="lpht"
                                className="col-md-2 col-form-label"
                              >
                                <h5 className="text-secondary fw-bold">LPHT</h5>
                              </label>
                              <div className="col-md-10 col-12">
                                <input
                                  className="form-control fs-5"
                                  disabled
                                  type="text"
                                  name="lpht"
                                  placeholder="12"
                                />
                              </div>
                            </div>
                            <div className="mb-3 row">
                              <label
                                htmlFor="real"
                                className="col-md-2 col-form-label"
                              >
                                <h5 className="text-secondary fw-bold">REAL</h5>
                              </label>
                              <div className="col-md-10 col-12">
                                <input
                                  className="form-control fs-5"
                                  disabled
                                  type="text"
                                  name="real"
                                  placeholder="12"
                                />
                              </div>
                            </div>
                            <div className="mb-3 row">
                              <label
                                htmlFor="jiram"
                                className="col-md-2 col-form-label"
                              >
                                <h5 className="text-secondary fw-bold">
                                  JIRAM
                                </h5>
                              </label>
                              <div className="col-md-10 col-12">
                                <input
                                  className="form-control fs-5"
                                  disabled
                                  type="text"
                                  name="jiram"
                                  placeholder="12"
                                />
                              </div>
                            </div>

                            <div className="mb-3 row">
                              <label
                                htmlFor="weight"
                                className="col-md-2 col-form-label"
                              >
                                <h5 className="text-secondary fw-bold">
                                  Weight
                                </h5>
                              </label>
                              <div className="col-md-10 col-12">
                                <input
                                  className="form-control fs-5" 
                                  disabled
                                  type="text"
                                  name="weight"
                                  placeholder="20.25 CT"
                                />
                              </div>
                            </div>
                            <div className="mb-3 row">
                              <label
                                htmlFor="pieces"
                                className="col-md-2 col-form-label"
                              >
                                <h5 className="text-secondary fw-bold">
                                  Pieces
                                </h5>
                              </label>
                              <div className="col-md-10 col-12">
                                <input
                                  className="form-control fs-5"
                                  disabled
                                  type="text"
                                  name="pieces"
                                  placeholder="12"
                                />
                              </div>
                            </div>
                            <div className="mb-3 row">
                              <label
                                htmlFor="inwardDate"
                                className="col-md-2 col-form-label"
                              >
                                <h5 className="text-secondary fw-bold">
                                  Inward Date
                                </h5>
                              </label>
                              <div className="col-md-10 col-12">
                                <input
                                  className="form-control fs-5"
                                  disabled
                                  type="text"
                                  name="inwardDate"
                                  placeholder="26/01/2022"
                                />
                              </div>
                            </div>
                          </form>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}
export default withTranslation()(ViewVarifyAndAccept);
